
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/tellers/[tellerId]",
      function () {
        return require("private-next-pages/phone/tellers/[tellerId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/tellers/[tellerId]"])
      });
    }
  